import {
    CREATE_TEST_REQUEST,
    CREATE_TEST_SUCCESS,
    CREATE_TEST_FAIL,
    GET_TEST_DETAIL_REQUEST,
    GET_TEST_DETAIL_SUCCESS,
    GET_TEST_DETAIL_FAIL,
    DELETE_TEST_REQUEST,
    DELETE_TEST_SUCCESS,
    DELETE_TEST_FAIL,
    UPDATE_TEST_REQUEST,
    UPDATE_TEST_SUCCESS,
    UPDATE_TEST_FAIL,
    GET_TESTS_LIST_REQUEST,
    GET_TESTS_LIST_SUCCESS,
    GET_TESTS_LIST_FAIL,
} from './actionTypes';
// /* CREATE TEST */
export const createTestRequest = (test) => {
    return {
        type: CREATE_TEST_REQUEST,
        payload: test,
    };
}

export const createTestSuccess = test => {
    return {
        type: CREATE_TEST_SUCCESS,
        payload: test,
    };
}

export const createTestFail = error => {
    return {
        type: CREATE_TEST_FAIL,
        payload: error,
    };
}

//GET TEST LIST
export const getTestsListRequest=()=>{
    return{
        type:GET_TESTS_LIST_REQUEST,
    }
}
export const getTestsListSuccess=(tests)=>{
    return{
        type:GET_TESTS_LIST_SUCCESS,
        payload:tests,
    }
}
export const getTestsListFail=(error)=>{
    return{
        type:GET_TESTS_LIST_FAIL,
        payload:error,
    }
}
//UPDATE TEST
export const updateTestRequest = (test,id) => ({
    type: UPDATE_TEST_REQUEST,
    payload: {test,id},
  })
  
export const updateTestSuccess = test => ({
    type: UPDATE_TEST_SUCCESS,
    payload: test,
  })
  
export const updateTestFail = error => ({
    type: UPDATE_TEST_FAIL,
    payload: error,
  })
//DELETE TEST

export const deleteTestRequest = test => ({
    type: DELETE_TEST_REQUEST,
    payload: test,
  })
  
  export const deleteTestSuccess = test => ({
    type: DELETE_TEST_SUCCESS,
    payload: test,
  })
  
  export const deleteTestFail = error => ({
    type: DELETE_TEST_FAIL,
    payload: error,
  })

//VIEW TEST DETAILS
export const getTestDetail = id => ({
    type: GET_TEST_DETAIL_REQUEST,
    payload: id,
  });
  
  export const getTestDetailSuccess = test => ({
    type: GET_TEST_DETAIL_SUCCESS,
    payload: test,
  });
  
  export const getTestDetailFail = error => ({
    type: GET_TEST_DETAIL_FAIL,
    payload: error,
  });

